module.exports = __webpack_public_path__ + "static/media/best-nikes-2017-nike-air-max-97-silver-bullet.3dca6c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/designers/best-nikes-2017-nike-air-max-97-silver-bullet.jpg
// module id = 153
// module chunks = 0